"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TourDataViewRoute = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _reactRedux = require("react-redux");

var _hooks = require("@nicbase/hooks");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseTranslation = require("nicbase-translation");

var _tourDataViewForm = _interopRequireDefault(require("./tour-data-view-form"));

var _tourDataViewHeader = _interopRequireDefault(require("./tour-data-view-header"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var LOCAL_STORAGE_TRANSLATION_CACHE_KEY = 'nb-translations';
var TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/Berlin';

var TourDataViewRoute = function TourDataViewRoute() {
  var _navigator;

  var dispatch = (0, _reactRedux.useDispatch)();
  var queryParams = new URLSearchParams(window.location.search);
  var tourName = queryParams.get('tourName') || '';
  var portalName = queryParams.get('portalName') || '';
  var tourToken = queryParams.get('tourToken');
  var image = queryParams.get('image') || null;
  var locale = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language) || 'en-GB';
  var languageCode = locale.substring(0, Math.max(2, locale.lastIndexOf('-')));
  var cachedTranslations = (0, _react.useMemo)(function () {
    var translationCache = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TRANSLATION_CACHE_KEY) || null);

    if ((translationCache === null || translationCache === void 0 ? void 0 : translationCache.language) === languageCode) {
      return translationCache.translations;
    }

    return null;
  }, [languageCode]);
  (0, _hooks.useDidMount)(function () {
    dispatch((0, _nicbaseReducers.changeLocale)(locale)); // load cached translations from local storage if available

    if (cachedTranslations) {
      dispatch((0, _nicbaseReducers.addTranslations)(languageCode, cachedTranslations));
    }
  }); // request to load translations if they are not in the local storage

  var _useQuery = (0, _reactQuery.useQuery)(['translations'], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = new URL(ENV.translationsRestAPI);
            url.searchParams.append('language', languageCode);
            url.searchParams.append('application', 'nic-place');
            return _context.abrupt("return", fetch(url, {
              cache: 'no-cache'
            }).then(function (response) {
              if (response.ok) {
                return response.json();
              }

              throw new Error(response.statusText);
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), {
    enabled: !cachedTranslations,
    onSuccess: function onSuccess(translations) {
      return dispatch({
        type: _nicbaseReducers.FIND_ALL_TRANSLATIONS_SUCCESS,
        body: {
          language: languageCode,
          translations: translations
        }
      });
    }
  }),
      isLoadingTranslations = _useQuery.isLoading;

  if (isLoadingTranslations) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex h-full"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null));
  }

  return /*#__PURE__*/_react["default"].createElement(_nicbaseReducers.UserProvider, {
    user: {
      locale: locale,
      timezone: TIME_ZONE,
      temperatureUnit: 'degC'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex flex-col"
  }, /*#__PURE__*/_react["default"].createElement(_tourDataViewHeader["default"], {
    name: tourName,
    image: image
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex flex-col bg-gray-100"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-8 lg:pl-24 font-bold pb-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.sharedBy",
    values: {
      portalName: portalName
    }
  })), /*#__PURE__*/_react["default"].createElement(_tourDataViewForm["default"], {
    tourToken: tourToken
  }))));
};

exports.TourDataViewRoute = TourDataViewRoute;
var _default = TourDataViewRoute;
exports["default"] = _default;